import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.div`
  padding: 0 10px;
`

export const DivTop = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const Span = styled.span`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 18px;
  color: ${colors.primaryText};
`

export const Painel = styled.div`
  background: ${colors.surface};
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 4px rgb(0 0 0 / 8%);
`

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  span:first-child {
    font-family: 'Poppins';
    font-size: 12px;
    color: ${colors.grey600};
  }
  span:last-child {
    font-family: 'Poppins';
    font-size: 14px;
    color: ${colors.primaryText};
    word-break: break-word;
  }
`

export const ConteudoLabel = styled.div`
  font-family: 'Poppins';
  font-size: 13px;
  font-weight: 600;
  color: ${colors.grey600};
  margin-bottom: 8px;
`

export const ConteudoTexto = styled.pre`
  font-family: 'Poppins';
  font-size: 14px;
  color: ${colors.grey900};
  white-space: pre-wrap;
  word-break: break-word;
  background: ${colors.grey100};
  border-radius: 8px;
  padding: 16px;
  margin: 0;
`

export const ConteudoFrame = styled.iframe`
  width: 100%;
  min-height: 420px;
  border: 1px solid ${colors.grey300};
  border-radius: 8px;
  /* EXCECAO ao tema escuro, de proposito: e o HTML do e-mail que foi enviado
     ao cliente final — fundo claro e texto escuro proprios. A regra
     color-scheme: dark nao atravessa a fronteira do documento do iframe.
     Ver a mesma decisao em components/EditorTemplate/style.ts. */
  background: ${colors.white};
`

export const ErroBox = styled.div`
  margin-top: 16px;
  background: ${colors.lightRed};
  color: ${colors.errorText};
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'Poppins';
  font-size: 13px;
  word-break: break-word;
`
